import Vue from 'vue'
import ElementUI from 'element-ui';
/**
 * @description 统一格式化去除input首尾空格
 * @date 2024-2-22
 */
Vue.component('el-input', {
  extends: ElementUI.Input,
  created() {
    this.$on('change', (value) => {
      this.$emit('input', value.trim())
    })
  }
})



// WEBPACK FOOTER //
// ./src/utils/el-input.js